import React from "react";
import {Button, Dialog, DialogActions, DialogTitle} from "@material-ui/core";
import {Values} from "Tools/Values";

interface IProps {
    isOpened: boolean
    onSubmit: () => void;
    onClose: () => void;
}

export const RemoveInternalAppDialog = ({isOpened, onSubmit, onClose}: IProps) => (
    <Dialog
        maxWidth={false}
        open={isOpened}
        onClose={() => onClose()}
        style={{padding: 24}}
    >
        <DialogTitle id="person-dialog-title">
            {Values.getLocalizationValue('areYouSureRemove')}
        </DialogTitle>

        <DialogActions style={{padding: 24}}>
            <Button
                variant="outlined"
                color="default"
                onClick={() => onClose()}
            >
                {Values.getLocalizationValue('cancel')}
            </Button>

            <Button
                variant="contained"
                color="primary"
                onClick={() => onSubmit()}
            >
                {Values.getLocalizationValue('confirm')}
            </Button>
        </DialogActions>
    </Dialog>
)
